module.exports = __webpack_public_path__ + "static/media/mobile-team-animated.14df3ef5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-team-animated.svg
// module id = 175
// module chunks = 0